import { useMutation, useQueryClient } from 'react-query';

import { client } from '@frontend/features/common/services';
import { QueryKeys } from '@frontend/features/common/types';

export const useDeleteQuickReply = (agencyId?: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (quickReplyId: number): Promise<void> => {
      if (!agencyId) {
        return Promise.reject(new Error('Agency ID is required'));
      }

      await client.delete(`/whatsapp/quick-replies/${agencyId}/${quickReplyId}`);
    },
    {
      onSuccess: () => {
        if (!agencyId) return;
        queryClient.invalidateQueries([QueryKeys.getWhatsappQuickReplies, agencyId]);
      },
    },
  );
};
